import styled from "@emotion/styled";
import { Link } from "atoms";

const ViewAllLink = styled(Link)(({ theme }) => ({
  color: theme.colors.gray60,
  fontSize: theme.fontSizes.xs,
  flex: "0 1 auto",
}));

export { ViewAllLink };
